@if (modelStrategy) {
  <div
    class="suggestion-strategy-card"
    style="background-image: url('{{modelStrategy.imageUrl}}');"
    (click)="routeToNewModelStrategy()"
    (keydown.space)="routeToNewModelStrategy()"
    (keydown.enter)="routeToNewModelStrategy()"
    tabindex="0"
    data-cy="model-strategy-card"
    >
    <div class="tag">
      <img src="{{ modelStrategy.iconUrl }}" alt="model strategy icon" class="svg">
    </div>
    <div class="footer">
      <div class="header">
        @if (!modelStrategy.translate) {
          {{ modelStrategy.name }}
        } @else {
          {{ modelStrategy.name | translate }}
        }
      </div>
    </div>
    <div class="blur-footer"></div>
  </div>
}
